export default __webpack_public_path__ + "images/ba13a974ec3d7687464a953234ce5d22.svg";